import { render, staticRenderFns } from "./MediaPostEditView.vue?vue&type=template&id=3d95e450&scoped=true&"
import script from "./MediaPostEditView.vue?vue&type=script&lang=ts&"
export * from "./MediaPostEditView.vue?vue&type=script&lang=ts&"
import style0 from "./MediaPostEditView.vue?vue&type=style&index=0&id=3d95e450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d95e450",
  null
  
)

export default component.exports